import { createSlice } from '@reduxjs/toolkit';
import { getEventImagesById } from '../thunks/eventThunk';

const initialState = {
  list: [],
  total: 0,
  loading: false,
  error: null,
};

const eventImages = createSlice({
  name: 'eventimages',
  initialState,
  reducers: {
    setData(state, action) {
      state.list = action.payload.data;
      state.total = action.payload.total;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEventImagesById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getEventImagesById.fulfilled, (state, action) => {
        state.list = action.payload.data;
        state.total = action.payload.total;
        state.loading = false;
      })
      .addCase(getEventImagesById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setData } = eventImages.actions;
export default eventImages.reducer;